import { endpoints } from 'Constants';

const services = {
	getPoseList: (filter) => ({
		baseURL: endpoints.POSE?.INDEX(filter),
		method: 'GET',
	}),
	addNewPos: (filter) => ({
		baseURL: endpoints.POSE.ADDPOSE(filter.id),
		method: 'POST',
		data: filter.data,
	}),
	deactivePos: (filter) => ({
		baseURL: endpoints.POSE.DEACTIVE(filter),
		method: 'POST',
		data: {
			workflow_state: 'inactive',
		},
	}),
	editPose: (filter) => ({
		baseURL: endpoints.POSE.EDITPOSE(filter.id),
		method: 'PUT',
		data: filter.data,
	}),
	getPackageList: (filter) => ({
		baseURL: endpoints.PACKAGE?.INDEX(filter),
		method: 'GET',
	}),
	getProductsList: (filter) => ({
		baseURL: endpoints.PACKAGE?.PRODUCTS_INDEX(
			filter.businessId,
			filter.params
		),
		method: 'GET',
	}),
	summaryBusiness: (params) => ({
		baseURL: endpoints.BUSINESS.MARKETING_REPORT(
			params.date,
			params.businessId
		),
		method: 'GET',
	}),
};

export default services;
